import gql from 'graphql-tag'
import { authClient, graphClient } from '../main'

export default class Auth {
    async signIn (email, password) {
        return graphClient.mutate({
            client: 'graphClient',
            // Query
            mutation: gql`mutation ($email: String!, $password: String) {
                signIn(
                    email: $email,
                    password: $password
                )
            }`,
            variables: {
                email: email,
                password: password
            }
        })
    }

    async signOut () {
        return authClient.mutate({
            client: 'authClient',
            // Query
            mutation: gql`mutation {
                signOut
            }`,
        })
    }

    getToken () {
        return $cookies.get('token');
    }

    setToken (token) {
        $cookies.set('token', token)
    }

    detectToken() {
        let urlParameter = window.location.search.substr(1)

        if (urlParameter.includes('token')) {
            return urlParameter.split('=')[1]
        }

        return false
    }

    async resetPasswordRequest(email) {
        return graphClient.mutate({
            client: 'graphClient',
            // Query
            mutation: gql`mutation ($email: String!) {
                requestResetPassword(email: $email)
            }`,
            variables: {
                email: email,
            }
        })
    }

    async resetPasswordReset(token, newPassword) {
        return graphClient.mutate({
            client: 'graphClient',
            // Query
            mutation: gql`mutation ($token: String, $password: String) {
                resetPassword(token: $token, password: $password)
            }`,
            variables: {
                token: token,
                password: newPassword,
            }
        })
    }

    setTokenTime() {
        const tokenTime = Date.now() + 2592000000;
        $cookies.set('tokenTime', tokenTime)
    }

    getTokenTime() {
        return $cookies.get('tokenTime')
    }
}
